import angular from 'angular';

const module = angular.module('Serveture-Services', []);

export default module;
